import React from "react";

interface LogoProps {
  href?: string;
  target?: string;
}

export const Logo: React.FC<LogoProps> = ({ href, target }) => {
  return (
    <a href={href} target={target}>
      <img src="/icons/logo.svg" alt="react" />
    </a>
  );
};